<app-error-boundary>
  <router-outlet />
</app-error-boundary>
